import { ChangeDetectionStrategy, Component, DestroyRef, OnInit, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { SharedModule } from 'app/shared/shared.module';
import { SetPasswordFormComponent } from '../set-password-form/set-password-form.component';
import { RecoveryService, RecoveryTokenResponse, RecoveryUser } from './recovery.service';

@Component({
  selector: 'mh-recovery',
  standalone: true,
  imports: [SharedModule, RouterModule, SetPasswordFormComponent],
  templateUrl: './recovery.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecoveryComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly recoveryService = inject(RecoveryService);
  private readonly destroyRef = inject(DestroyRef);

  readonly titleKey: string = this.route.snapshot.data.titleKey ?? 'recovery.title';
  readonly explainKey: string = this.route.snapshot.data.explainKey ?? 'recovery.explain';

  readonly waiting = signal(true);
  readonly errorTag = signal<string | null>(null);
  readonly token = signal('');
  readonly user = signal<RecoveryUser | null>(null);

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('token');
    if (!token) {
      void this.router.navigate(['/login']);
      return;
    }
    this.token.set(token);

    this.recoveryService
      .validateToken(token)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response) => this.handleValidToken(response),
        error: (error) => this.handleTokenError(error),
      });
  }

  navigateToForgotPassword(): void {
    void this.router.navigate(['/recordar-contrasena']);
  }

  private handleValidToken(response: RecoveryTokenResponse): void {
    if (response?.tag) this.errorTag.set('errors.recovery.' + response.tag);
    else this.user.set(response);
    this.waiting.set(false);
  }

  private handleTokenError(error: RecoveryTokenResponse): void {
    this.errorTag.set(error?.tag ? 'errors.recovery.' + error.tag : 'errors.login.something_went_wrong');
    this.waiting.set(false);
  }
}
